export default __webpack_public_path__ + "static/media/bk.nayak.d9567e24.jpeg";